"use client";

import { type ModulePageHeading } from "@lib/types";

import { ResponsiveImage } from "@/components/shared/ResponsiveImage";
import { Container } from "@/components/ui/container";
import { cn } from "@/lib/ui/cn";

interface PageHeadingModuleProps {
  module: ModulePageHeading;
  pageTitle?: string;
}

export function PageHeadingModule({ module, pageTitle }: PageHeadingModuleProps) {
  const heading = module.heading || pageTitle || "";

  return (
    <Container as="section" className={cn("py-padding-section-sm relative")}>
      {module.backgroundMedia && (
        <ResponsiveImage
          src={module.backgroundMedia}
          fill
          className="absolute inset-0 -z-10 object-cover"
        />
      )}
      <div className="inline-flex flex-col items-start justify-start gap-6 px-8">
        {heading ? (
          <h1 className="typography-heading-2 w-full tracking-wide text-white">{heading}</h1>
        ) : null}
        {module.subheading ? (
          <div className="typography-text-large-normal text-neutral-light max-w-[928px]">
            {module.subheading}
          </div>
        ) : null}
      </div>
    </Container>
  );
}
